import { render, staticRenderFns } from "./HotelItem.vue?vue&type=template&id=af9ed0a8&"
import script from "./HotelItem.vue?vue&type=script&lang=js&"
export * from "./HotelItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports